export default __webpack_public_path__ + "static/media/atlbrokenphones.a603ebc5.svg";